import { render, staticRenderFns } from "./confirm-load-email-template.vue?vue&type=template&id=58eef50a"
import script from "./confirm-load-email-template.vue?vue&type=script&lang=js"
export * from "./confirm-load-email-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports